import { css } from '@emotion/react'
import { COLORS } from 'theme/theme'

export const negative = css`
  color: ${COLORS.red};
`

export const positive = css`
  color: ${COLORS.dark};
`

export const neutral = css`
  color: ${COLORS.yellow};
`
